export default __webpack_public_path__ + "static/media/Refund-Policy.f4d83879.jpg";